import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Tras un deploy, los assets con hash antiguo dejan de existir en el servidor.
// Un cliente desactualizado que navega a una ruta lazy recibe un 404 al
// precargar el chunk, y Vite emite `vite:preloadError`. Recargamos una sola vez
// para que el usuario baje el index.html con los hashes nuevos, con un guard
// temporal para no entrar en bucle si el asset está realmente roto.
window.addEventListener('vite:preloadError', (event) => {
	const KEY = 'vite-preload-reload-ts';
	const last = Number(window.sessionStorage.getItem(KEY) ?? 0);
	if (Date.now() - last > 10_000) {
		window.sessionStorage.setItem(KEY, String(Date.now()));
		event.preventDefault();
		window.location.reload();
	}
});

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
